module.exports = __webpack_public_path__ + "img/nespresso_limited_vertuo_next_jade.4e5320e.jpg";